"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _OfficersModule = _interopRequireDefault(require("./Officers.module.css"));

var _grommet = require("grommet");

var _Officer = _interopRequireDefault(require("./Officer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var Officers = /*#__PURE__*/function (_React$Component) {
  _inherits(Officers, _React$Component);

  var _super = _createSuper(Officers);

  function Officers(props) {
    var _this;

    _classCallCheck(this, Officers);

    _this = _super.call(this, props);
    _this.state = {
      num: 0,
      printArray: [],
      ready: false,
      fontSize: '10px'
    };
    _this.generateArray = _this.generateArray.bind(_assertThisInitialized(_this));
    _this["switch"] = _this["switch"].bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Officers, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (window.innerWidth > 767 || window.innerWidth <= 454) {
        this.generateArray(2);
      } else if (window.innerWidth > 454 && window.innerWidth <= 574) {
        this.generateArray(3);
      } else if (window.innerWidth > 574 && window.innerWidth <= 694) {
        this.generateArray(4);
      } else if (window.innerWidth > 694 && window.innerWidth <= 767) {
        this.generateArray(5);
      }
    }
  }, {
    key: "generateArray",
    value: function generateArray(num) {
      var length = this.props.officers.length;
      var printArray = [];

      if (num === 2) {
        for (var l = 0; l < length; l += num) {
          var block;

          if (l + num - 1 < length) {
            block = /*#__PURE__*/_react["default"].createElement(_grommet.Box, {
              id: _OfficersModule["default"].list_div
            }, /*#__PURE__*/_react["default"].createElement(_Officer["default"], {
              name: this.props.officers[l].name,
              title: this.props.officers[l].position,
              calendly: this.props.officers[l].calendly,
              color: this.props.color
            }), /*#__PURE__*/_react["default"].createElement(_Officer["default"], {
              name: this.props.officers[l + 1].name,
              title: this.props.officers[l + 1].position,
              calendly: this.props.officers[l + 1].calendly,
              color: this.props.color
            }));
          } else {
            block = /*#__PURE__*/_react["default"].createElement(_grommet.Box, {
              id: _OfficersModule["default"].list_div
            }, /*#__PURE__*/_react["default"].createElement(_Officer["default"], {
              name: this.props.officers[l].name,
              title: this.props.officers[l].position,
              calendly: this.props.officers[l].calendly,
              color: this.props.color
            }));
          }

          printArray.push(block);
        }
      } else if (num === 3) {
        for (var j = 0; j < length; j += num) {
          var block2;

          if (j + num - 1 < length) {
            block2 = /*#__PURE__*/_react["default"].createElement(_grommet.Box, {
              id: _OfficersModule["default"].list_div
            }, /*#__PURE__*/_react["default"].createElement(_Officer["default"], {
              name: this.props.officers[j].name,
              title: this.props.officers[j].position,
              calendly: this.props.officers[j].calendly,
              color: this.props.color
            }), /*#__PURE__*/_react["default"].createElement(_Officer["default"], {
              name: this.props.officers[j + 1].name,
              title: this.props.officers[j + 1].position,
              calendly: this.props.officers[j + 1].calendly,
              color: this.props.color
            }), /*#__PURE__*/_react["default"].createElement(_Officer["default"], {
              name: this.props.officers[j + 2].name,
              title: this.props.officers[j + 2].position,
              calendly: this.props.officers[j + 2].calendly,
              color: this.props.color
            }));
          } else if (j + num - 1 === length) {
            block2 = /*#__PURE__*/_react["default"].createElement(_grommet.Box, {
              id: _OfficersModule["default"].list_div
            }, /*#__PURE__*/_react["default"].createElement(_Officer["default"], {
              name: this.props.officers[j].name,
              title: this.props.officers[j].position,
              calendly: this.props.officers[j].calendly,
              color: this.props.color
            }), /*#__PURE__*/_react["default"].createElement(_Officer["default"], {
              name: this.props.officers[j + 1].name,
              title: this.props.officers[j + 1].position,
              calendly: this.props.officers[j + 1].calendly,
              color: this.props.color
            }));
          } else if (j + num - 2 === length) {
            block2 = /*#__PURE__*/_react["default"].createElement(_grommet.Box, {
              id: _OfficersModule["default"].list_div
            }, /*#__PURE__*/_react["default"].createElement(_Officer["default"], {
              name: this.props.officers[j].name,
              title: this.props.officers[j].position,
              calendly: this.props.officers[j].calendly,
              color: this.props.color
            }));
          }

          printArray.push(block2);
        }
      } else if (num === 4) {
        for (var k = 0; k < length; k += num) {
          var block3;

          if (k + num - 1 < length) {
            block3 = /*#__PURE__*/_react["default"].createElement(_grommet.Box, {
              id: _OfficersModule["default"].list_div
            }, /*#__PURE__*/_react["default"].createElement(_Officer["default"], {
              name: this.props.officers[k].name,
              title: this.props.officers[k].position,
              calendly: this.props.officers[k].calendly,
              color: this.props.color
            }), /*#__PURE__*/_react["default"].createElement(_Officer["default"], {
              name: this.props.officers[k + 1].name,
              title: this.props.officers[k + 1].position,
              calendly: this.props.officers[k + 1].calendly,
              color: this.props.color
            }), /*#__PURE__*/_react["default"].createElement(_Officer["default"], {
              name: this.props.officers[k + 2].name,
              title: this.props.officers[k + 2].position,
              calendly: this.props.officers[k + 2].calendly,
              color: this.props.color
            }), /*#__PURE__*/_react["default"].createElement(_Officer["default"], {
              name: this.props.officers[k + 3].name,
              title: this.props.officers[k + 3].position,
              calendly: this.props.officers[k + 3].calendly,
              color: this.props.color
            }));
          } else if (k + num - 1 === length) {
            block3 = /*#__PURE__*/_react["default"].createElement(_grommet.Box, {
              id: _OfficersModule["default"].list_div
            }, /*#__PURE__*/_react["default"].createElement(_Officer["default"], {
              name: this.props.officers[k].name,
              title: this.props.officers[k].position,
              calendly: this.props.officers[k].calendly,
              color: this.props.color
            }), /*#__PURE__*/_react["default"].createElement(_Officer["default"], {
              name: this.props.officers[k + 1].name,
              title: this.props.officers[k + 1].position,
              calendly: this.props.officers[k + 1].calendly,
              color: this.props.color
            }), /*#__PURE__*/_react["default"].createElement(_Officer["default"], {
              name: this.props.officers[k + 2].name,
              title: this.props.officers[k + 2].position,
              calendly: this.props.officers[k + 2].calendly,
              color: this.props.color
            }));
          } else if (k + num - 2 === length) {
            block3 = /*#__PURE__*/_react["default"].createElement(_grommet.Box, {
              id: _OfficersModule["default"].list_div
            }, /*#__PURE__*/_react["default"].createElement(_Officer["default"], {
              name: this.props.officers[k].name,
              title: this.props.officers[k].position,
              calendly: this.props.officers[k].calendly,
              color: this.props.color
            }), /*#__PURE__*/_react["default"].createElement(_Officer["default"], {
              name: this.props.officers[k + 1].name,
              title: this.props.officers[k + 1].position,
              calendly: this.props.officers[k + 1].calendly,
              color: this.props.color
            }));
          } else if (k + num - 3 === length) {
            block3 = /*#__PURE__*/_react["default"].createElement(_grommet.Box, {
              id: _OfficersModule["default"].list_div
            }, /*#__PURE__*/_react["default"].createElement(_Officer["default"], {
              name: this.props.officers[k].name,
              title: this.props.officers[k].position,
              calendly: this.props.officers[k].calendly,
              color: this.props.color
            }));
          }

          printArray.push(block3);
        }
      } else if (num === 5) {
        for (var i = 0; i < length; i += num) {
          var block4;

          if (i + num - 1 < length) {
            block4 = /*#__PURE__*/_react["default"].createElement(_grommet.Box, {
              id: _OfficersModule["default"].list_div
            }, /*#__PURE__*/_react["default"].createElement(_Officer["default"], {
              name: this.props.officers[i].name,
              title: this.props.officers[i].position,
              calendly: this.props.officers[i].calendly,
              color: this.props.color
            }), /*#__PURE__*/_react["default"].createElement(_Officer["default"], {
              name: this.props.officers[i + 1].name,
              title: this.props.officers[i + 1].position,
              calendly: this.props.officers[i + 1].calendly,
              color: this.props.color
            }), /*#__PURE__*/_react["default"].createElement(_Officer["default"], {
              name: this.props.officers[i + 2].name,
              title: this.props.officers[i + 2].position,
              calendly: this.props.officers[i + 2].calendly,
              color: this.props.color
            }), /*#__PURE__*/_react["default"].createElement(_Officer["default"], {
              name: this.props.officers[i + 3].name,
              title: this.props.officers[i + 3].position,
              calendly: this.props.officers[i + 3].calendly,
              color: this.props.color
            }), /*#__PURE__*/_react["default"].createElement(_Officer["default"], {
              name: this.props.officers[i + 4].name,
              title: this.props.officers[i + 4].position,
              calendly: this.props.officers[i + 4].calendly,
              color: this.props.color
            }));
          } else if (i + num - 1 === length) {
            block4 = /*#__PURE__*/_react["default"].createElement(_grommet.Box, {
              id: _OfficersModule["default"].list_div
            }, /*#__PURE__*/_react["default"].createElement(_Officer["default"], {
              name: this.props.officers[i].name,
              title: this.props.officers[i].position,
              calendly: this.props.officers[i].calendly,
              color: this.props.color
            }), /*#__PURE__*/_react["default"].createElement(_Officer["default"], {
              name: this.props.officers[i + 1].name,
              title: this.props.officers[i + 1].position,
              calendly: this.props.officers[i + 1].calendly,
              color: this.props.color
            }), /*#__PURE__*/_react["default"].createElement(_Officer["default"], {
              name: this.props.officers[i + 2].name,
              title: this.props.officers[i + 2].position,
              calendly: this.props.officers[i + 2].calendly,
              color: this.props.color
            }), /*#__PURE__*/_react["default"].createElement(_Officer["default"], {
              name: this.props.officers[i + 3].name,
              title: this.props.officers[i + 3].position,
              calendly: this.props.officers[i + 3].calendly,
              color: this.props.color
            }));
          } else if (i + num - 2 === length) {
            block4 = /*#__PURE__*/_react["default"].createElement(_grommet.Box, {
              id: _OfficersModule["default"].list_div
            }, /*#__PURE__*/_react["default"].createElement(_Officer["default"], {
              name: this.props.officers[i].name,
              title: this.props.officers[i].position,
              calendly: this.props.officers[i].calendly,
              color: this.props.color
            }), /*#__PURE__*/_react["default"].createElement(_Officer["default"], {
              name: this.props.officers[i + 1].name,
              title: this.props.officers[i + 1].position,
              calendly: this.props.officers[i + 1].calendly,
              color: this.props.color
            }), /*#__PURE__*/_react["default"].createElement(_Officer["default"], {
              name: this.props.officers[i + 2].name,
              title: this.props.officers[i + 2].position,
              calendly: this.props.officers[i + 2].calendly,
              color: this.props.color
            }));
          } else if (i + num - 3 === length) {
            block4 = /*#__PURE__*/_react["default"].createElement(_grommet.Box, {
              id: _OfficersModule["default"].list_div
            }, /*#__PURE__*/_react["default"].createElement(_Officer["default"], {
              name: this.props.officers[i].name,
              title: this.props.officers[i].position,
              calendly: this.props.officers[i].calendly,
              color: this.props.color
            }), /*#__PURE__*/_react["default"].createElement(_Officer["default"], {
              name: this.props.officers[i + 1].name,
              title: this.props.officers[i + 1].position,
              calendly: this.props.officers[i + 1].calendly,
              color: this.props.color
            }));
          } else if (i + num - 4 === length) {
            block4 = /*#__PURE__*/_react["default"].createElement(_grommet.Box, {
              id: _OfficersModule["default"].list_div
            }, /*#__PURE__*/_react["default"].createElement(_Officer["default"], {
              name: this.props.officers[i].name,
              title: this.props.officers[i].position,
              calendly: this.props.officers[i].calendly,
              color: this.props.color
            }));
          }

          printArray.push(block4);
        }
      }

      this.setState({
        printArray: printArray,
        ready: true,
        num: num
      });
    }
  }, {
    key: "switch",
    value: function _switch() {
      if (this.state.num !== 2) {
        this.generateArray(2);
      } // else if (window.innerWidth > 454 && window.innerWidth <= 574  && this.state.num !== 3) {
      //     this.generateArray(3);
      // }
      // else if (window.innerWidth > 574 && window.innerWidth <= 694 && this.state.num !== 4) {
      //     this.generateArray(4);
      // }
      // else if(window.innerWidth > 694 && window.innerWidth <= 767 && this.state.num !== 5) {
      //     this.generateArray(5);
      // }

    }
  }, {
    key: "render",
    value: function render() {
      this["switch"]();
      return /*#__PURE__*/_react["default"].createElement("div", {
        id: _OfficersModule["default"].padding
      }, /*#__PURE__*/_react["default"].createElement(_grommet.Box, {
        id: _OfficersModule["default"].outer_div
      }, /*#__PURE__*/_react["default"].createElement("div", {
        id: _OfficersModule["default"].officers,
        style: {
          color: this.props.color
        }
      }, "Officers"), this.state.ready ? /*#__PURE__*/_react["default"].createElement(_grommet.Carousel, {
        fill: true,
        id: _OfficersModule["default"].carousel
      }, this.state.printArray.map(function (item, index) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: index
        }, item);
      })) : /*#__PURE__*/_react["default"].createElement("div", null)));
    }
  }]);

  return Officers;
}(_react["default"].Component);

var _default = Officers;
exports["default"] = _default;

//# sourceMappingURL=Officers.js.map